import $ from 'jquery';

export default function() {
    var processing = false;

    this.ajaxProcessing = function() {
        processing = true;
    };

    this.ajaxSuccess = function(data, status, jqr) {
        processing = false;
    };

    this.ajaxError = function(jqr, status, exception) {
        processing = false;
    };

    this.ajaxComplete = function(jqr, status) {};

    this.submitForm = function(extraData) {
        var action = this.attr.action || this.$node.attr('action');
        var method = this.attr.method || this.$node.attr('method');
        var data = this.$node.serializeArray();

        if (extraData) {
            data = data.concat(extraData);
        }

        if (!processing) {
            this.makeRequest(action, method, data);

            if (extraData) {
                this.ajaxProcessing(extraData[0]);
            } else {
                this.ajaxProcessing();
            }
        }
    };

    this.makeRequest = function(action, method, data) {
        $.ajax({
            url: action,
            type: method,
            error: this.ajaxError,
            success: this.ajaxSuccess,
            complete: this.ajaxComplete,
            data: $.param(data),
            context: this,
        });
    };
}



// WEBPACK FOOTER //
// ./src/web/js/launch/modules/mixins/with-async-form.js